import { Controller } from "@hotwired/stimulus"
import { patch, destroy } from "@rails/request.js"

// Connects to data-controller="notifications"
export default class extends Controller {
  static values ={
    updateUrl: String,
    notificationId: Number,
    deleteUrl: String
  }

  markAsRead(event) {
    patch(this.updateUrlValue, {
      body: {
        id: this.notificationIdValue
      },
      responseKind: "turbo-stream"
    })
  }

  deleteNotification(event) {
    event.preventDefault()
    event.stopPropagation()

    destroy(this.deleteUrlValue, {
      responseKind: "turbo-stream"
    })
  }
}
